export class TmAccount {
    public CustomerEDP: number;
    public CustomerNo: string;
    public Email: string;
    public BillingAddress: TmAddress;
    public ShippingAddresses: TmAddress[];
    public CreditCards: TmCreditCard[];
    public CustomerId: number;
    public IsFraud: boolean;
    public HasAvailableCredit: boolean;
    public IsGuest: boolean;
    public IsEmployee: boolean;
    public IsRogersEmployee: boolean;
    public Nickname: string;
    public SalesForceCustomerId: string;
    public AccessToken: string;
}

//AddressModel is common to both Billing & Shipping Addresses
export class TmAddress {
    public Id: number;
    public FirstName: string;
    public LastName: string;
    public DayPhone: string;
    public Street: string;
    public AddressRef1: string;
    public City: string;
    public State: string;
    public ZipCode: string;
    public IsDefault: boolean;
    public POBoxNumber: string;
    public IsPOBox: boolean;
    public SalesForceAddressId: string;
}

export class TmCreditCard {
    public Id: number;
    public ExpirationDate: Date;
    public Expired: boolean;
    public Number: string;
    public MaskedNumber: string;
    public IsDefault: boolean;
    public Type: string;
    public DisplayExpirationMonth: string;
    public DisplayExpirationYear: string;
    public CVV: string;
    public IsIssuerRogers: boolean;
}
export class TmCreditCardRequest {
    public Id: number;
    public Number: string;
    public MaskedNumber: string;
    public IsDefault: boolean;
    public Type: string;
    public DisplayExpirationMonth: string;
    public DisplayExpirationYear: string;
    public CVV: string;
    public ReCaptchaToken: string;
    public ClientIP: string;
}

export interface TmHostedCreditCardRequest {
    HostedSessionId: string;
    ClientIp?: string;
    ReCaptchaToken: string;
    IsDefault?: boolean;
    BillingAddress?: {
        CardHolderName?: string;
        Street?: string;
        City?: string;
        Province?: string;
        Country?: string;
        PostalCode?: string;
    };
}

export enum TmCreditCardType {
    Visa = 'VI',
    MasterCard = 'MC',
    Amex = 'AX',
    TSC = 'FI',
}

export enum TmCreditCardSelectionType {
    NonTSC = 'standardCreditCard',
    TSC = 'tscCreditCard',
    PayPal = 'payPal',
}
export enum TmProvince {
    AB,
    BC,
    MB,
    NB,
    NL,
    NT,
    NS,
    NU,
    ON,
    PE,
    QC,
    SK,
    YT,
}
